module.exports = __webpack_public_path__ + "static/media/ios-add-icon.4827fd92.svg";